'use client';
import type { HeadingProps } from '@mv/web-ui';
import { cx } from 'class-variance-authority';
import type { HTMLAttributes, RefAttributes } from 'react';
import type { RichTextContent } from '@/payload/components/RichText/RichText';
import { serializeLexical } from './serialize';
import styles from '../RichText/RichText.module.scss';

export type RichHeadingProps = RefAttributes<HTMLSpanElement> &
	Omit<HTMLAttributes<HTMLSpanElement>, 'content'> & {
		content: RichTextContent;
		options?: Omit<HeadingProps, 'children'>;
	};

export default function RichHeading({ content, className, options, ...props }: RichHeadingProps) {
	if (!content) {
		return null;
	}

	return (
		<span className={cx(styles.richText, className)} {...props}>
			{content &&
				!Array.isArray(content) &&
				typeof content === 'object' &&
				'root' in content &&
				serializeLexical({
					nodes: content?.root?.children ?? [],
					options: options,
				})}
		</span>
	);
}
